module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-linear-progress",
    style: ({
      'height': _vm.size + 'px',
      'border-radius': (_vm.size ? _vm.size / 2 : '') + 'px'
    })
  }, [_c('div', {
    class: _vm.linearClass,
    style: (_vm.linearStyle)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03abb7b3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/linearProgress/linearProgress.vue
// module id = 3580
// module chunks = 1